import { Box } from '@mui/material'
import type { DropTargeProps } from './types'
import { useDrop } from 'react-dnd'
import { NativeTypes } from 'react-dnd-html5-backend'
import type { PropsWithChildren } from 'react'

export const DropTarget = (props: PropsWithChildren<DropTargeProps>) => {
  const { onDrop, children } = props

  const [{ canDrop, isOver }, drop] = useDrop(
    () => ({
      accept: [NativeTypes.FILE],
      drop: (item: { files: File[] }) => {
        onDrop(item.files)
      },
      //canDrop: () => !disabled,
      collect: (monitor) => ({
        isOver: monitor.isOver(),
        canDrop: monitor.canDrop(),
      }),
    }),
    [onDrop]
  )

  return <Box ref={drop}>{children}</Box>
}
